
<div class="position-relative">
  <ng-container *ngIf="!isDashbAccess; else noAccess">
    <div class="mb-5" *ngIf="from_page == 'login'">
      <div class="fw-bolder text-center"> Verify your {{selectedIndex == 0 ? 'Email' : 'Mobile'}} </div>
    </div>

    <form [formGroup]="verification_form" class="position-relative">
        <ng-container *ngIf="from_page == 'signup'">
          <span [innerHTML]="send_otp_response?.message" class="position-absolute otp-text"></span>
        </ng-container>

        <div class="row">
          <mat-tab-group class="verify-section-wrapper" [(selectedIndex)]="selectedIndex" (selectedTabChange)="onTabChanged($event)">

            <!-- <ng-container *ngIf="login_response.data?.email_verified != '1' && login_response.data?.office_email != ''">
            </ng-container> -->
            <mat-tab disabled>
              <div class="col-12 position-relative">
                <!-- <mat-form-field class="w-100" floatLabel="always">
                    <mat-label>Office Email</mat-label>
                    <input matInput placeholder="Email" formControlName="office_email" aria-label="Office email address">
                    <mat-icon *ngIf="account?.email_verified == '1'" matSuffix style="color:green">verified_user</mat-icon>
                </mat-form-field> -->

                <div [style.visibility]="account?.email_verified == '1' ? 'hidden': 'visible'">
                  <div class="otp-container">
                    <label class="otp-label" id="email-otp-label" for="email-otp-0">Enter Code sent on your email</label>
                    <div class="otp-inputs-wrapper" role="group" aria-labelledby="email-otp-label">
                      <input 
                        *ngFor="let i of otpIndexes; trackBy: trackByIndex"
                        #emailOtp
                        type="text" 
                        inputmode="numeric"
                        maxlength="1"
                        class="otp-input"
                        [id]="'email-otp-' + i"
                        [name]="'email-otp-' + i"
                        [attr.data-index]="i"
                        [value]="emailOtpInputs[i]"
                        [attr.aria-label]="'OTP digit ' + (i + 1) + ' of 6'"
                        aria-labelledby="email-otp-label"
                        (input)="onOtpInput($event, i, 'email')"
                        (keydown)="onOtpKeyDown($event, i, 'email')"
                        (paste)="onOtpPaste($event, 0, 'email')"
                        autocomplete="off"
                      />
                    </div>
                    <div class="otp-hint-wrapper">
                      <span 
                        class="otp-hint" 
                        [class.resend-otp-hint]="!is_office_email_otp_timeout"
                        (click)="is_office_email_otp_timeout ? '' : resendOTP('email')">
                        {{ is_office_email_otp_timeout ? 'Resend Code in ' + office_email_time_remaining + 's' : 'RESEND' }}
                      </span>
                    </div>
                    <div class="otp-error" *ngIf="verification_form.get('office_email_otp')?.hasError('required') && verification_form.get('office_email_otp')?.touched">
                      Verification Code is <strong>required</strong>
                    </div>
                  </div>

                <div class="col-12 d-flex justify-content-center my-5">
                  <button #emailVerifyBtn type="button" class="btn btn-sm verify-btn" [disabled]="verification_form.get('office_email_otp').invalid || is_email_verifying" mat-flat-button (click)="verifyAccount('office_email')">
                    <span *ngIf="!is_email_verifying">
                      Verify
                    </span>
                    <span *ngIf="is_email_verifying">
                      <mat-spinner diameter="18" class="mx-auto"></mat-spinner>
                    </span>
                    </button>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center" *ngIf="account?.email_verified == '1'">
                  <mat-spinner diameter="25"></mat-spinner>
                </div>
              </div>
            </mat-tab>

            <!-- <ng-container *ngIf="login_response.data?.sms_verified != '1' && login_response.data?.mobile != '' && login_response.data.country_code == '91'">
            </ng-container> -->
            <mat-tab disabled>
              <div class="col-12 position-relative mt-2">
                <!-- <mat-form-field class="w-100" floatLabel="always">
                    <mat-label>Mobile No.</mat-label>
                    <span matPrefix>+{{this.verification_form.value.country_code}} &nbsp;</span>
                    <input matInput type="number" placeholder="Mobile" formControlName="mobile_number" aria-label="Mobile number">
                    <mat-icon *ngIf="account?.sms_verified == '1'" matSuffix style="color:green">verified_user</mat-icon>
                </mat-form-field> -->

                <div [style.visibility]="account?.sms_verified == '1' ? 'hidden': 'visible'">
                  <div class="otp-container">
                    <label class="otp-label" id="mobile-otp-label" for="mobile-otp-0">Enter Verification Code on your mobile number</label>
                    <div class="otp-inputs-wrapper" role="group" aria-labelledby="mobile-otp-label">
                      <input 
                        *ngFor="let i of otpIndexes; trackBy: trackByIndex"
                        #mobileOtp
                        type="text" 
                        inputmode="numeric"
                        maxlength="1"
                        class="otp-input"
                        [id]="'mobile-otp-' + i"
                        [name]="'mobile-otp-' + i"
                        [attr.data-index]="i"
                        [value]="mobileOtpInputs[i]"
                        [attr.aria-label]="'OTP digit ' + (i + 1) + ' of 6'"
                        aria-labelledby="mobile-otp-label"
                        (input)="onOtpInput($event, i, 'mobile')"
                        (keydown)="onOtpKeyDown($event, i, 'mobile')"
                        (paste)="onOtpPaste($event, 0, 'mobile')"
                        autocomplete="off"
                      />
                    </div>
                    <div class="otp-hint-wrapper">
                      <span 
                        class="otp-hint" 
                        [class.resend-otp-hint]="!is_mobile_otp_timeout"
                        (click)="is_mobile_otp_timeout ? '' : resendOTP('mobile')">
                        {{ is_mobile_otp_timeout ? 'Resend Code in ' + mobile_time_remaining + 's' : 'RESEND' }}
                      </span>
                    </div>
                    <div class="otp-error" *ngIf="verification_form.get('mobile_no_otp')?.hasError('required') && verification_form.get('mobile_no_otp')?.touched">
                      Verification Code is <strong>required</strong>
                    </div>
                  </div>

                  <div class="col-12 d-flex justify-content-center my-5">
                    <button #mobileVerifyBtn type="button" class="btn btn-sm verify-btn" [disabled]="verification_form.get('mobile_no_otp').invalid || is_mobile_verifying" mat-flat-button (click)="verifyAccount('mobile')">
                      <span *ngIf="!is_mobile_verifying">
                        Verify
                      </span>
                      <span *ngIf="is_mobile_verifying">
                        <mat-spinner diameter="18" class="mx-auto"></mat-spinner>
                      </span>
                    </button>
                  </div>
                </div>
                <div class="d-flex justify-content-center align-items-center" *ngIf="account?.sms_verified == '1'">
                  <mat-spinner diameter="25"></mat-spinner>
                </div>
              </div>
            </mat-tab>

          </mat-tab-group>

          <div class="d-flex justify-content-center align-items-center pb-1 gap-3">
            <span class="redirecting-msg" *ngIf="show_counter">
              Redirecting to Truein Dashboard in {{counter}}s
            </span>
            <!-- <button type="button" class="my-0 next-btn" mat-button (click)="onNext()" [disabled]="!((account?.sms_verified === '1' && selectedIndex == 0) || (account?.email_verified === '1' && selectedIndex == 1))">
                {{ selectedIndex == 0 || (selectedIndex == 1 && login_response.data?.client_details?.length > 1) ? 'Next' : 'Go To Truein Dashboard' }}
            </button>

            <button type="button" class="my-0 skip-btn" mat-button (click)="onNext()" *ngIf="from_page != 'signup'">
                Skip
            </button> -->
          </div>
        </div>
    </form>
  </ng-container>

  <ng-template #noAccess>
    <div class="no-access-text text-center">
      <strong [innerHTML]="isDashbAccess"></strong>
    </div>
  </ng-template>
</div>
